<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import SitePageFormFields from '@components/site-pages/form-fields.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, Trash2, ChevronLeft, Globe } from 'lucide-svelte'

  let { site_page } = $props()

  const form = useForm({
    title: site_page?.title || '',
    slug: site_page?.slug || '',
    content: site_page?.content?.html || '',
    show_on_signup: site_page?.show_on_signup || false,
  })

  const deleteForm = useForm({})

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform(data => ({ site_page: data }))
    $form.put(`/admin/site_pages/${site_page.id}`, {
      onSuccess: () => router.visit('/admin/site_pages'),
    })
  }

  function handleDelete() {
    if (!window.confirm(`Are you sure you want to delete "${site_page.title}"?`)) return
    $deleteForm.delete(`/admin/site_pages/${site_page.id}`, {
      onSuccess: () => router.visit('/admin/site_pages'),
    })
  }

  let navigationProps = {
    title: site_page?.title || "Edit site page",
    links: [{ text: "Admin", href: "/admin" }, { text: "Site Pages", href: "/admin/site_pages" }],
  }
</script>

<Page.Layout title={site_page?.title || "Edit site page"}>

  <Page.Navigation {...navigationProps} />

  <Page.Titles title={site_page?.title || "Edit site page"} subtitle="Edit this site page">
    {#snippet buttons()}
      <Button text="Back" path="/admin/site_pages" BeforeIcon={ChevronLeft} />
      <Button variant="warning" text="Delete" Icon={Trash2} onclick={handleDelete} loading={$deleteForm.processing} />
      <Button type="submit" form="site-page-form" text="Update" variant="submit" Icon={Save} loading={$form.processing} />
      <Button path={`/${site_page.slug}`} Icon={Globe} hint="View site page" />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="site-page-form" onsubmit={handleSubmit}>
    <SitePageFormFields {form} sitePage={site_page} />
  </Form.Element>

</Page.Layout>
